import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { IntlShape, injectIntl } from 'react-intl';
import { CircularProgress, Box, Grid } from '@material-ui/core';
import { connect } from 'react-redux';

import { getQuestionSecretSelector } from 'store/credentials/selectors';
import Header from 'containers/SignupPages/Header';
import messages from 'containers/SignupPages/CreatePassword/messages';
import { translate } from 'helpers/intl';
import Form from 'containers/SignupPages/CreatePassword/Form';
import { getQuestionSecret } from 'store/credentials/actions';
import { setSignupStep } from 'store/user/actions';
import { getIsLoadingQuestionSelector } from 'store/credentials/selectors';
import { PERSONAL_INFO } from 'containers/SignupPages/constants';

export type QuestionSecret = {
  label: string;
  value: string;
};
export type QuestionSecretProps = {
  intl: IntlShape;
  isLoading: boolean;
  isLoadingQuestion: boolean;
  getQuestionSecret: Function;
  onSubmitStep: Function;
  questionSecret: QuestionSecret[];
  setSignupStep: Function;
};

const CreatePassword = (props: QuestionSecretProps) => {
  /* eslint-disable */
    useEffect(() => {
        props.getQuestionSecret();
    }, []);
    /* eslint-enable */
  return (
    <React.Fragment>
      <Header
        title={translate({ ...messages.title }, props)}
        subTitle={translate({ ...messages.subTitle }, props)}
      />
      {!props.isLoadingQuestion && props.questionSecret.length ? (
        <Form
          isLoading={props.isLoading}
          getQuestionSecret={props.getQuestionSecret}
          questionSecret={props.questionSecret}
          onClickPrevious={
            /* istanbul ignore next */ () => {
              props.setSignupStep(PERSONAL_INFO);
            }
          }
          onSubmitStep={props.onSubmitStep}
        />
      ) : (
        <Box p={13}>
          <Grid justify="center" alignItems="center" container>
            <CircularProgress data-testid="loader" size={40} />
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  { questionSecret: QuestionSecret[]; isLoadingQuestion: boolean }
>({
  questionSecret: getQuestionSecretSelector,
  isLoadingQuestion: getIsLoadingQuestionSelector,
});

const mapDispatchToProps = {
  getQuestionSecret,
  setSignupStep,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CreatePassword));
